import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import Table from '../../components/Table';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import Chip from '@mui/material/Chip';
import BrazilMoney from 'utils/BrazilMoney';

function OccurrencesList() {
  // const selectedOccurrence = useSelector(
  //   (state) => state.selectedOccurrence.selectedOccurrence
  // );
  const [occurrences, setOccurrences] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);
  const [user, setUser] = useState(null);
  const [dialogIsOpen, setDialogIsOpen] = useState(false);

  useEffect(() => {
    async function ini() {
      setUser(await api.get('users'));
    }
    ini();
  }, []);

  useEffect(() => {
    if (user?.data.firstAccess === true) setDialogIsOpen(true);
  }, [user]);

  function handleStatus(_rowData) {
    if (_rowData.status === 'Concluído') {
      return (
        <Chip
          style={{
            backgroundColor: '#0B8846',
            color: '#fff',
            fontWeight: 'bold',
          }}
          label={_rowData.status}
        />
      );
    }

    if (_rowData.status === 'Em análise') {
      return (
        <Chip
          style={{
            backgroundColor: '#E2D907',
            color: '#fff',
            fontWeight: 'bold',
          }}
          label={_rowData.status}
        />
      );
    }

    if (_rowData.status !== 'Concluído' && _rowData.status !== 'Em análise') {
      return (
        <Chip
          style={{
            backgroundColor: '#f44336',
            color: '#fff',
            fontWeight: 'bold',
          }}
          label={_rowData.status}
        />
      );
    }
  }

  const columns = [
    {
      title: 'Data da Observação',
      field: 'first_observation',
      type: 'date',
      hideFilterIcon: true,
      editable: 'never',
    },
    {
      title: 'Tipo do problema',
      // field: "type",
      // hideFilterIcon: true,
    }, // alterar
    {
      title: 'Grau do problema',
      // field: "degree",
      // hideFilterIcon: true,
    },
    {
      title: 'Prejuízo estimado(R$)',
      // field: "estimated_loss",
      render: (rowData) => (
        <BrazilMoney value={rowData.estimated_loss} />
        // <>{new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(rowData.estimated_loss)}</>
      ),
      hideFilterIcon: true,
    },
    {
      title: 'Status da Ocorrência',
      // field: "status",
      // hideFilterIcon: true,
    }, // alterar
  ];

  // useEffect(() => {
  //   async function loadData() {
  //     try {
  //       const response = await api.get(
  //         "/occurrences/occurrence-code/" + selectedOccurrence.id
  //       );

  //       if (response.data.length === 0) {
  //         setOpenProgress(true);
  //       }

  //       if (response.data) {
  //         let data = response.data;
  //         let organizedData = data.map((occurrence) => ({
  //           id: occurrence.id,
  //           pond: occurrence.pond,
  //           cycleCode: occurrence.cycleCode,
  //           begin:
  //             occurrence.begin === null
  //               ? "Ainda não iniciado"
  //               : moment(occurrence.begin).format("DD/MM/YYYY"),
  //           end:
  //             occurrence.end === null
  //               ? "Ainda não concluído"
  //               : moment(occurrence.end).format("DD/MM/YYYY"),
  //           population: occurrence.population,
  //           description: occurrence.pond.description,
  //           status: occurrence.status,
  //           observation: occurrence.observation,
  //           density: occurrence.density,
  //         }));
  //         setExportData(organizedData);
  //         setOccurrences(data);
  //         setOpenProgress(true);
  //       }
  //     } catch (err) {
  //
  //     }
  //   }
  //   loadData();
  // }, [openProgress, selectedOccurrence]);

  function setData(newData) {
    const tempData = [];
    occurrences.map((occurrence) => (occurrence.id === newData.id
      ? tempData.push(newData)
      : tempData.push(occurrence)));
    setOccurrences(tempData);
  }
  return (
    <>
      <Dialog open={dialogIsOpen} fullWidth>
        <DialogTitle>
          Ultimo passo para poder iniciar a usar o sistema
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            No canto inferior direito da sua tela, clique no mais para cadastrar
            a ocorrência
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogIsOpen(false)}>ok</Button>
        </DialogActions>
      </Dialog>

      <Table
        title="Ocorrências"
        route="/occurrences"
        routeAdd="/new-occurrence"
        columns={columns}
        data={occurrences}
        setData={setData}
        // dataLoaded={openProgress}
        copy={false}
        exportData={exportData}
      />
    </>
  );

  //   const [occurrences, setOccurrences] = useState([]);
  //   let history = useHistory();
  //   const [openProgress, setOpenProgress] = useState(false);

  //   useEffect(() => {
  //     async function loadData() {
  //       try {
  //         const response = await api.get("/occurrences");
  //
  //         if (response.data.length === 0) {
  //           setOpenProgress(true);
  //         }
  //         if (response.data) {
  //           setOccurrences(response.data);
  //           setOpenProgress(true);
  //         }
  //       } catch (err) {
  //
  //       }
  //     }
  //     loadData();
  //   }, []);

  //   const handleClick = (id) => {
  //
  //     history.push("/occurrence/" + id);
  //   };

  //   return (
  //     <ThemeProvider theme={tableTheme}>
  //       <Container>
  //         <br />
  //         <MaterialTable
  //           title="Ocorrências"
  //           columns={[
  //             {
  //               title: "Data da Observação",
  //               // field: "first_observation",
  //               // type: "date",
  //               // hideFilterIcon: true,
  //             },
  //             {
  //               title: "Tipo do problema",
  //               // field: "type",
  //               // hideFilterIcon: true,
  //             }, //alterar
  //             {
  //               title: "Grau do problema",
  //               // field: "degree",
  //               // hideFilterIcon: true,
  //             },
  //             {
  //               title: "Prejuízo estimado(R$)",
  //               // field: "estimated_loss",
  //               render: (rowData) => {
  //                 return (
  //                   <>
  //                     <BrazilMoney value={rowData.estimated_loss} />
  //                   </>
  //                   // <>{new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(rowData.estimated_loss)}</>
  //                 );
  //               },
  //               hideFilterIcon: true,
  //             },
  //             {
  //               title: "Status da Ocorrência",
  //               // field: "status",
  //               // hideFilterIcon: true,
  //             }, //alterar
  //           ]}
  //           data={occurrences}
  //           editable={{
  //             onRowUpdate: (newData, oldData) =>
  //               new Promise((resolve, reject) => {
  //                 setTimeout(() => {
  //                   const dataUpdate = [...occurrences];
  //                   const index = oldData.tableData.id;
  //                   dataUpdate[index] = newData;
  //                   setOccurrences(dataUpdate);
  //                   api.put("/occurrences/" + oldData.id, { ...newData });
  //                   resolve();
  //                 }, 1000);
  //               }),
  //           }}
  //           localization={{
  //             header: {
  //               actions: "",
  //             },
  //             body: {
  //               emptyDataSourceMessage: (
  //                 <>
  //                   {openProgress ? (
  //                     "Nenhum registro para exibir"
  //                   ) : (
  //                     <CircularProgress />
  //                   )}
  //                 </>
  //               ),
  //               filterRow: {
  //                 filterTooltip: "Filtro",
  //               },
  //             },
  //             toolbar: {
  //               searchTooltip: "Pesquisar",
  //               searchPlaceholder: "Pesquisar",
  //               exportTitle: "Exportar",
  //               exportCSVName: "Exportar como CSV",
  //               exportPDFName: "Exportar como PDF",
  //             },
  //             pagination: {
  //               labelRowsSelect: "linhas",
  //               labelDisplayedRows: "{count} de {from}-{to}",
  //               firstTooltip: "Primeira página",
  //               previousTooltip: "Página anterior",
  //               nextTooltip: "Próxima página",
  //               lastTooltip: "Última página",
  //             },
  //           }}
  //           options={{
  //             filtering: true,
  //             exportButton: true,
  //             search: true,
  //             pageSize: 10,
  //             pageSizeOptions: [10, 15, 20, 50, 100],
  //             sorting: true,
  //           }}
  //           onRowClick={(evt, rowData) => handleClick(rowData.id)}
  //         />
  //         <div>
  //           <Container>
  //             <FabButton to="/new-occurrence" />
  //           </Container>
  //         </div>
  //         <br />
  //       </Container>
  //     </ThemeProvider>
  //   );
}

export default OccurrencesList;
